module.exports = __webpack_public_path__ + "static/media/3.c80281eb.JPG";